import React from "react"
import classNames from "classnames"
import { CheckCircleFilled } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation'

// Components
import Button from "../../../../../../components/Button"
import AuthFormPlate from "../../../../components/AuthFormPlate"

// Models
import { SpecializationSelectProps } from "./index"

// Constants
import { DoctorSpecialization } from "../../../../../../constants"

const SpecializationSelect = (props: SpecializationSelectProps) => {
    const { className, handleContinue, handleSelect, selected, handleBack } = props;
    const { t } = useTranslation();

    return (
        <AuthFormPlate
            title={t('common:auth.specialization')}
            description={t('common:auth.choose_your_specialization')}
            handleBack={handleBack}
        >
            <div className={className}>
                {DoctorSpecialization.map(s => {
                    const isActive = s.id === selected;

                    return (
                        <div
                            key={s.id}
                            onClick={() => handleSelect(s.id)}
                            className={classNames("item", isActive && "item__active")}
                        >
                            <img
                                alt={s.title}
                                src={`/static/assets/specialization/${s.id.toLowerCase()}.png`}
                                srcSet={`/static/assets/specialization/${s.id.toLowerCase()}.png, 
                             /static/assets/specialization/${s.id.toLowerCase()}@2x.png 2x, 
                             /static/assets/specialization/${s.id.toLowerCase()}@3x.png 3x`}
                            />
                            {isActive && (
                                <CheckCircleFilled />
                            )}
                            <span className="label">
                                {t(`common:auth.${s.title}`)}
                            </span>
                        </div>
                    )
                })}
                <Button
                    block
                    type="primary"
                    onClick={handleContinue}
                    disabled={selected === null}
                >
                    {t('common:continue')}
                </Button>
            </div>
        </AuthFormPlate>
    )
}

export default SpecializationSelect;